var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5892 0.00209367C24.9208 -0.0729087 29.9924 1.86882 33.8474 5.56893C37.7023 9.26738 39.884 14.2475 39.9956 19.5877C40.1056 24.9295 38.129 29.993 34.429 33.8481C30.7307 37.7033 25.7524 39.8867 20.4108 39.9967L20.4059 39.9967C20.2659 39.9984 20.1275 40 19.9875 40C14.8025 40 9.90426 38.0316 6.15096 34.4298C2.29767 30.7314 0.114355 25.7512 0.00435571 20.4111C-0.105643 15.0692 1.871 10.0057 5.5693 6.15062C9.26927 2.2955 14.2459 0.113764 19.5892 0.00209367ZM12.8446 18.8163L16.6662 22.6381L27.1544 12.1495L29.5111 14.5062L17.8445 26.1732C17.5195 26.4982 17.0929 26.6616 16.6662 26.6616C16.2395 26.6616 15.8129 26.4982 15.4879 26.1732L10.4879 21.1731L12.8446 18.8163Z",
    fill: "#1D964F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.b03ae3e0c1dcb3019426c299439a29e2.svg";
export { ForwardRef as ReactComponent };